(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!window.sprynklThumbnailHoverBound) {
  window.sprynklThumbnailHoverBound = true;

  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  document.addEventListener('mouseover', (event) => {
    if (!finePointer.matches) return;
    if (!event.target || !event.target.closest) return;

    const item = event.target.closest('media-gallery .thumbnail-list__item[data-target]');
    if (!item) return;
    if (event.relatedTarget && item.contains(event.relatedTarget)) return;

    const button = item.querySelector('button.thumbnail');
    if (!button || button.getAttribute('aria-current') === 'true') return;

    const gallery = item.closest('media-gallery');
    const mediaId = item.dataset.target;
    if (gallery && typeof gallery.setActiveMedia === 'function' && gallery.elements && gallery.elements.viewer) {
      gallery.setActiveMedia(mediaId, false);
      return;
    }

    button.click();
  });
}
  } catch(e) { console.error(e); }
})();

})();
